import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  errorMessage?: string;
  className?: string;
}

const FormControl: FC<IProps> = ({ children, errorMessage, className }) => (
  <div className={classNames(css.control, className)}>
    <div className={css.control__content}>{children}</div>
    {errorMessage && <div className={css.control__errorMessage}>{errorMessage}</div>}
  </div>
);

export default FormControl;
